/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Divider, Grid, Group, Paper, SimpleGrid, Space, Text, ThemeIcon } from '@mantine/core';
import { IconScale, IconZoomMoney } from '@tabler/icons-react';
import { Tabs } from 'antd';
import PageSection from '../../../../../../../components/core/PageSection/PageSection';
import PageViewAudit from '../../../../../../../components/core/PageViewAudit/PageViewAudit';
import PageViewProperty from '../../../../../../../components/core/PageViewProperty/PageViewProperty';
import ProfileCardLink from '../../../../../../../components/core/ProfileCardLink/ProfileCardLink';
import { EventServiceQuotationType } from '../../../../../../../models/core/events.type';
import { Feature } from '../../../../../../../utils/constants.utils';
import { formatCurrency } from '../../../../../../../utils/formatter.utils';
import { isNullOrEmpty } from '../../../../../../../utils/helper.utils';
import ProposalItemToleranceView from '../../../../../proposals/ProposalView/components/components/components/ProposalItemToleranceView';

type DataViewProps = {
  data: EventServiceQuotationType;
};

export default function EventServiceItem(props: DataViewProps) {
  const buildTabs = () => {
    const tabs = [
      {
        key: 'Cotacao',
        label: (
          <Group>
            <ThemeIcon color={Feature.Home.Event.color} variant="outline">
              <IconZoomMoney size={18} />
            </ThemeIcon>
            <Text size="md" color={Feature.Home.Event.color} style={{ fontWeight: 500 }}>
              Cotação
            </Text>
          </Group>
        ),
        children: (
          <div>
            <Paper shadow="xs" p="md" withBorder>
              <PageSection
                size="md"
                color={Feature.Home.Event.color}
                label="Cliente"
                text="Informações operacionais da cotação com o cliente."
              />
              <Space h="xs" />
              <Grid columns={5}>
                <Grid.Col span={1}>
                  <PageViewProperty
                    label="Quantidade"
                    text={
                      props.data.precificacao?.quantidade && props.data.precificacao?.quantidadeUnidadeMedida
                        ? `${props.data.precificacao.quantidade} ${props.data.precificacao.quantidadeUnidadeMedida}`
                        : props.data.precificacao?.quantidade?.toString() || '-'
                    }
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={2}>
                  <PageViewProperty
                    label="Frequência"
                    text={props.data.precificacao?.frequenciaUnidadeMedida || '-'}
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={1}>
                  <PageViewProperty
                    label="Preço"
                    text={
                      isNullOrEmpty(props.data.precificacao?.preco)
                        ? '-'
                        : formatCurrency(props.data.precificacao!.preco!)
                    }
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={1}>
                  <PageViewProperty
                    label="Imposto"
                    text={
                      isNullOrEmpty(props.data.precificacao?.imposto)
                        ? '-'
                        : `${props.data.precificacao!.imposto}%`
                    }
                    size="sm"
                  />
                </Grid.Col>
              </Grid>
            </Paper>
            <Space h="md" />

            <Paper shadow="xs" p="md" withBorder>
              <PageSection
                size="md"
                color={Feature.Home.Event.color}
                label="Fornecedor"
                text="Informações operacionais da cotação com o fornecedor."
              />
              <Space h="xs" />
              <Grid columns={5}>
                <Grid.Col span={2}>
                  {props.data.fornecedorCNPJ ? (
                    <PageViewProperty
                      label="Fornecedor"
                      text={
                        <ProfileCardLink
                          id={props.data.idFornecedor?.toString() || '???'}
                          name={props.data.fornecedorNomeFantasia || props.data.fornecedorRazaoSocial || '-'}
                          nameSize="sm"
                          description={
                            props.data.fornecedorNomeFantasia
                              ? props.data.fornecedorRazaoSocial
                              : props.data.fornecedorCNPJ
                          }
                          descriptionSize="xs"
                          linkPrefix="entities"
                        />
                      }
                      size="sm"
                    />
                  ) : (
                    <PageViewProperty
                      label="Fornecedor"
                      text={
                        <ProfileCardLink
                          id={props.data.idFornecedor?.toString() || '???'}
                          name={props.data.fornecedorNome || '-'}
                          nameSize="sm"
                          description={props.data.fornecedorCPF}
                          descriptionSize="xs"
                          linkPrefix="entities"
                        />
                      }
                      size="sm"
                    />
                  )}
                </Grid.Col>
                <Grid.Col span={1}>
                  <PageViewProperty
                    label="Quantidade"
                    text={props.data.quantidade?.toString() || '-'}
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={1}>
                  <PageViewProperty
                    label="Frequência"
                    text={`${
                      props.data.quantidade
                        ? `${`${props.data.frequenciaUnidadeMedida1} / ${props.data.frequenciaUnidadeMedida2}`}`
                        : '-'
                    }`}
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={1}>
                  <PageViewProperty
                    label="Preço"
                    text={isNullOrEmpty(props.data.preco) ? '-' : formatCurrency(props.data.preco)}
                    size="sm"
                  />
                </Grid.Col>
              </Grid>
              <Divider my="sm" variant="dotted" />

              <SimpleGrid cols={1}>
                <PageViewProperty label="Observação" text={props.data.observacao || '-'} size="sm" />
              </SimpleGrid>
            </Paper>
            <Space h="lg" />

            <PageViewAudit
              idCriadoPor={props.data.idCriadoPor}
              criadoPor={props.data.criadoPor}
              dataCriacao={props.data.dataCriacao}
              idModificadoPor={props.data?.idModificadoPor || null}
              modificadoPor={props.data?.modificadoPor || null}
              dataModificacao={props.data?.dataModificacao || null}
              size="sm"
              gridSize={2}
            />
          </div>
        ),
        forceRender: true,
      },
      {
        key: 'Tolerancias',
        label: (
          <Group>
            <ThemeIcon color={Feature.Home.Event.color} variant="outline">
              <IconScale size={18} />
            </ThemeIcon>
            <Text size="md" color={Feature.Home.Event.color} style={{ fontWeight: 500 }}>
              Tolerâncias
            </Text>
          </Group>
        ),
        children: (
          <Paper shadow="xs" p="md" withBorder>
            <ProposalItemToleranceView data={props.data.tolerancias} />
          </Paper>
        ),
        forceRender: true,
      },
    ];
    return tabs;
  };

  return (
    <div>
      <Paper shadow="xs" p="md" withBorder>
        <Tabs items={buildTabs()} defaultActiveKey="Cotacao" />
      </Paper>
    </div>
  );
}
